"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationOwnerApply',
  data: function data() {
    return {
      loading: false,
      list: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    actionText: function actionText(value) {
      return {
        approve: '通过',
        reject: '驳回',
        withdraw: '撤回'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationOwnerApplyListApi)({
        page: 1,
        limit: 50
      }).then(function (data) {
        _this.list = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    runAction: function runAction(row, action) {
      var _this2 = this;
      (0, _decoration.decorationOwnerApplyActionApi)(row.apply.id, {
        action: action
      }).then(function () {
        _this2.$message.success('已更新');
        _this2.reload();
      });
    }
  }
};